/*
    Copyright 2022-2026, Techwise Integrated Security, LLC
*/

import { selectRoles } from "../auth/authSlice";
import { Box, Button, Stack, Tooltip, Typography } from "@mui/material";
import { NavigateFunction, useNavigate } from "react-router-dom";
import { ArrowBack, Home } from "@mui/icons-material";
import { useAppSelector } from "../../app/hooks";

export interface ValidateRolesProps {
    roles: string[];
    children?: JSX.Element | JSX.Element[];
}

const ValidateRoles = (props: ValidateRolesProps) => {
    const { roles, children } = props;
    const requiredRoles: string[] = roles;
    const userRoles = useAppSelector(selectRoles);

    const navigate: NavigateFunction = useNavigate();

    let valid: boolean = false;

    for (let index in requiredRoles) {
        let requiredRole: string = requiredRoles[index];
        if (userRoles.includes(requiredRole)) {
            valid = true;
            break;
        }
    }

    if (valid) {
        return <>{children}</>;
    }

    let requiredRolesStr: string = requiredRoles.join(", ");

    return (
        <Box>
            <Typography variant="h5" sx={{ mb: 2 }}>
                Access Denied
            </Typography>
            <Typography sx={{ mb: 2 }}>You do not have the required roles to access this content.</Typography>

            {requiredRoles.length === 1 && (
                <Typography sx={{ mb: 2 }} component="span">
                    You are missing the following role:&nbsp;<Typography fontWeight="bold">{requiredRoles[0]}</Typography>
                </Typography>
            )}

            {requiredRoles.length > 1 && (
                <Typography sx={{ mb: 2 }} component="span">
                    You are missing any of the following roles:&nbsp;<Typography fontWeight="bold">{requiredRolesStr}</Typography>
                </Typography>
            )}

            <Stack direction="row" sx={{ mt: 5 }}>
                <Tooltip title="Return to the previous page">
                    <Button onClick={() => navigate(-1)} sx={{ mr: 4 }}>
                        <ArrowBack sx={{ mr: 2 }} />
                        <Stack direction="column" justifyContent="center">
                            <Typography>Back</Typography>
                        </Stack>
                    </Button>
                </Tooltip>
                <Tooltip title="Return to the home page">
                    <Button variant="contained" onClick={() => navigate("/")}>
                        <Home sx={{ mr: 2 }} />
                        <Stack direction="column" justifyContent="center">
                            <Typography>Home</Typography>
                        </Stack>
                    </Button>
                </Tooltip>
            </Stack>
        </Box>
    );
};

export default ValidateRoles;
